import { forwardRef, useId } from "react";
import type { IconsaxProps } from "./Iconsax.types.js";

export const CardLinear = forwardRef<HTMLDivElement, IconsaxProps>(({ size = 24, color = "currentColor", ...rest }, ref) => {
    const clipId = useId();
    return (
        <div ref={ref} {...rest} style={{ display: "flex", width: "fit-content", alignItems: "center", justifyContent: "center", ...rest.style }}>
            <svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <g clipPath={`url(#${clipId})`}>
                    <path d="M2 8.50488H22" stroke={color} strokeWidth="1.5" strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round" />
                    <path d="M6 16.5049H8" stroke={color} strokeWidth="1.5" strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round" />
                    <path
                        d="M10.5 16.5049H14.5"
                        stroke={color}
                        strokeWidth="1.5"
                        strokeMiterlimit="10"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                    />
                    <path
                        d="M6.44 3.50488H17.55C21.11 3.50488 22 4.38488 22 7.89488V16.1049C22 19.6149 21.11 20.4949 17.56 20.4949H6.44C2.89 20.5049 2 19.6249 2 16.1149V7.89488C2 4.38488 2.89 3.50488 6.44 3.50488Z"
                        stroke={color}
                        strokeWidth="1.5"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                    />
                </g>
                <defs>
                    <clipPath id={clipId}>
                        <rect width="24" height="24" fill="none" />
                    </clipPath>
                </defs>
            </svg>
        </div>
    );
});
